import { Injectable } from '@angular/core';
import { CollectorApi } from 'src/app/shared/apis/collector.api';
import { FingerprintService } from './fingerprint.service';
import { LocalStorageService } from './localstorage.service';

@Injectable({
  providedIn: 'root',
})
export class CollectorService {
  constructor(
    private localStorageService: LocalStorageService,
    private fpService: FingerprintService,
    private collectorApi: CollectorApi
  ) {}

  /**
   * 自動傳送APP下載第三方推薦碼
   */
  async sendAppInviteCode() {
    const inviteCode = this.localStorageService.inviteCodeSignal() || '';
    const ip = this.localStorageService.clientIp || '';

    const extendedResult = await this.fpService.identifyExtended('app-download', true);
    const { device, os, osVersion } = extendedResult;

    this.collectorApi.sendInviteCodeInfo({ inviteCode, ip, device, os, osVersion }).subscribe();
  }
}
